// extracted by mini-css-extract-plugin
export default {"fontGotham":"badge_fontGotham__DbtMX","badge":"badge_badge__mnnHl"};